// @flow
import React from 'react';
import type { SimilarContentType } from 'types/Article';
import type { FullUserType } from 'types/User';
import { dynamicClassName } from 'utils/dynamicClassName';
import { formatFullDate } from 'utils/dateUtils';
import { getDateFromString } from 'utils/dateUtils';
import BackgroundImage from 'components/fragments/BackgroundImage';
import { handleTagEvent } from 'utils/tagManagerUtils';

export type StateProps = { 
  userPref: FullUserType
};

type Props = StateProps & {
  content: SimilarContentType,
  row?: boolean,
  largeRow?: boolean
};

const SimilarContent = (props: Props) => {
  const { largeRow, row, userPref } = props;
  const { background_image, description, label, link, title } = props.content;
  const date = getDateFromString(props.content.date);

  const classNamesNewsContainer = dynamicClassName('news');
  largeRow && classNamesNewsContainer.add('news--row-lg');
  row && classNamesNewsContainer.add('news--row');

  return (
    <a
      key={props.content.date}
      href={link}
      title={`Lire la suite de l'article : ${title}`}
      role="button"
      tabIndex={0}
      className={classNamesNewsContainer.build()}
      onClick={handleTagEvent('module_actualite', title, '', userPref)}
      rel="nofollow"
    >
      <article className="card--similar-content--classic">
        <span className="border"></span>
        <BackgroundImage
          className="news__thumbnail img-blue"
          illustration={background_image}
          forceState={largeRow ? 'thumbnail' : 'medium'}
        />
        <div>
          <span className="news__title ft-h4">{title}</span>
          <p className="ft-h6">
            <span className="news__cat ft-up">{label.name}</span>
            <span className="news__date">{formatFullDate(date)}</span>
          </p>
          {!!description && <p className="news__desc">{description}</p>}
        </div>
      </article>
    </a>
  );
};

export default SimilarContent;
